import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

let router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        title: '极客晨星编程课堂'
      }
    },
    {
      path: '/login',
      name: 'login',
      meta: {
        title: '极客晨星编程课堂'
      },
      component: () => import('./views/Login.vue')
    },
    {
      path: '/packages',
      name: 'packages',
      meta: {
        title: '极客晨星编程课堂'
      },
      component: () => import('./views/Packages.vue')
    },
    {
      path: '/works',
      name: 'works',
      meta: {
        title: '作品详情'
      },
      component: () => import('./views/Works.vue')
    },
    {
      path: '/worklist',
      name: 'worklist',
      meta: {
        title: '我的作品'
      },
      component: () => import('./views/WorkList.vue')
    },
    // 播放视频的  *** 测试用的
    {
      path: '/video',
      name: 'video',
      meta: {
        title: '极客晨星编程课堂'
      },
      component: () => import('./views/Video.vue')
    },
    // 404 放在最后
    // {
    //   path: '/404',
    //   name: 'page404',
    //   component: () => import('./views/Error.vue')
    // }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  if (to.name !== 'login' && to.name !== 'works') {
    Vue.axios.get("/whoami").then((res) => {
      if (res.data.mobile) {
        next()
      } else {
        // router.push({ path: '/loginindex', query: { redirect: to.fullPath }})
        next('/login')
      }
    }).catch((error) => {
    })
  } else {
    if(to.name === 'login'){
      Vue.axios.get("/whoami").then((res) => {
        if (res.data.mobile) {
          next('/')
        } else {
          next()
        }
      }).catch((error) => {
        console.log(error, '**error in router**');
      })
    }else{
      next()
    }
  }
})

export default router
